const augment = (proto: Object, name: string, value: unknown) =>
  Object.defineProperty(proto, name, { value, enumerable: false });

function tap<T>(this: T, f: (value: T) => any): T {
  f(this);
  return this;
}

function pipe<T, R>(this: T, f: (value: T) => R): R {
  return f(this);
}

declare global {
  interface Object {
    $tap: typeof tap;
    $pipe: typeof pipe;
    get $json(): string;
  }
}

augment(Object.prototype, "$tap", tap);
augment(Object.prototype, "$pipe", pipe);
Object.defineProperty(Object.prototype, "$json", {
  get: function () {
    return JSON.stringify(this);
  },
  enumerable: false,
});

function mapError<T, R>(this: Promise<T>, f: (err: unknown) => R): Promise<T> {
  return this.catch((err) => {
    throw f(err);
  });
}

function withTimeout<T>(
  this: Promise<T>,
  delay: number,
  error?: () => unknown
): Promise<T> {
  const timeoutToken = Symbol();
  const sleep = new Promise<typeof timeoutToken>((resolve) =>
    setTimeout(() => resolve(timeoutToken), delay)
  );

  return Promise.race([this, sleep]).then((ret) => {
    if (ret === timeoutToken)
      return Promise.reject(error ? error() : new Error("timed out"));
    return Promise.resolve(ret);
  });
}

declare global {
  interface Promise<T> {
    $mapError: typeof mapError;
    $withTimeout: typeof withTimeout;
  }
}

augment(Promise.prototype, "$mapError", mapError);
augment(Promise.prototype, "$withTimeout", withTimeout);
